module.exports = __webpack_public_path__ + "static/media/SF-1.7077de2e.mp3";